/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var messageDefaultProps = {
  closeBtn: void 0,
  duration: 3e3,
  icon: true,
  theme: "info"
};

export { messageDefaultProps };
//# sourceMappingURL=defaultProps.js.map
